import { action, observable } from 'mobx';

/**
 * 值改变的 store
 */
class ValueChangeStore {
  @observable value;

  constructor({ value }) {
    this.value = value;
  }

  @action.bound
  onChange(value) {
    this.value = value;
  }
}

export default ValueChangeStore;
